const state={
    // originRoute:null,
    checkin_info:null,
    volunteer_info:null,
    patient_service_item:null,//患者服务单个数据-更新患者服务回显
    // doctor_visit_item:null,//医护拜访单个数据
    predict_ids:null,//监督发药的领药人id-{name,id}
    newSupervise:null,//新建监督发药数据-新增监督发药回显
    front_status:'',
    addUploadStatus:false,//是否是公益专员补传材料阶段
    // newsFeed_patient_service_id:null,//患者服务id-间隔传值  newsFeed->/* patientDetails */->addService
}

const getters={
    // originRoute:null,
}

const  mutations={
    // setOriginRoute(state,originRoute){
    //     console.log("设置originRoute为:",originRoute)
    //     state.originRoute=originRoute;
    // },
    setCheckin_info(state,checkin_info){
        console.log("设置checkin_info为:",checkin_info)
        state.checkin_info=checkin_info;
    },
    setVolunteer_info(state,volunteer_info){
        console.log("设置volunteer_info为:",volunteer_info)
        state.volunteer_info=volunteer_info;
    },
    setPatient_service_item(state,patient_service_item){
        console.log("设置patient_service_item为:",patient_service_item)
        state.patient_service_item=patient_service_item;
    },
    setDoctor_visit_item(state,doctor_visit_item){
        console.log("设置doctor_visit_item为:",doctor_visit_item)
        state.doctor_visit_item=doctor_visit_item;
    },
    setPredict_ids(state,predict_ids){
        console.log("设置predict_ids为:",predict_ids)
        state.predict_ids=predict_ids;
    },
    setNewSupervise(state,newSupervise){
        console.log("设置newSupervise为:",newSupervise)
        state.newSupervise=newSupervise;
    },
    clearNewSupervise(state){
        console.log("清空newSupervise")
        state.newSupervise=null;
    },
    clearPredict_ids(state){
        console.log("清空predict_ids")
        state.predict_ids=null;
    },
    clearPublicWelfareStaff(state){
        console.log("清空publicWelfareStaff")
        state.checkin_info=null;
        state.volunteer_info=null;
        state.patient_service_item=null;
        state.predict_ids=null;
        state.newSupervise=null;
    },
    setAddUploadStatus(state,addUploadStatus) {
        state.addUploadStatus = addUploadStatus
    },
    clearAddUploadStatus(state) {
        state.addUploadStatus = false
    },
    setFrontStatus(state,front_status) {
        state.front_status = front_status
    },
    clearFrontStatus(state) {
        state.front_status = ''
    }
}

const actions={
    // originRoute:null,
}

export default { state, getters, mutations, actions };